const menuWidth = 310;
/**
 * スタイル定義
 */
export const styles = (theme) => {
  return {
    content: {
      flexGrow: 1,
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: menuWidth + theme.spacing.unit,
    },
    menuClose: {
      paddingLeft: theme.spacing.unit,
    },
    progress: {
      position: 'absolute',
      top: 50,
      left: 0,
      margin: 0,
      padding: 0,
      height: 4,
      width: '100%',
    },
  };
};
